import { GESTIONNAIRE_FIELD } from 'business/constants';
import {
    CHAPTER_FIELD,
    NATURE_FIELD,
    FUNCTION_FIELD,
    OPERATION_FIELD,
    ORG_CHART_FINANCE_FIELD,
    ANALYTIC_NAME_FIELD,
    BUDGET_LINE_PROGRAM_NAME,
    ENVELOPPE_LABEL,
    ANALYTIC_NATURE_NAME,
} from 'routes/BudgetModule/config/constants';
import { ExpenseIncomeImputationDataT } from '../hooks/expenseIncomeImputations';

/* Options displayed by BudgetProposalChart */
const IMPUTATIONS_OPTIONS_BY_SOFTWARE: Record<
    string,
    Extract<
        keyof ExpenseIncomeImputationDataT,
        | 'chapter.code'
        | 'nature.number'
        | 'function.number'
        | 'operation.code'
        | 'gestionnaire.name'
        | 'orgChartFinance.tree'
        | 'analytic.name'
        | 'budgetLineProgram.name'
        | 'enveloppe.label'
        | 'analyticNature.name'
    >[]
> = {
    DEFAULT: [
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        OPERATION_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
    ],
    SIFAC: [CHAPTER_FIELD, OPERATION_FIELD, ANALYTIC_NAME_FIELD],
    GRAND_ANGLE: [
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        OPERATION_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        BUDGET_LINE_PROGRAM_NAME,
        ENVELOPPE_LABEL,
        ANALYTIC_NATURE_NAME,
    ],
};

/**
 * Given a list of integratedSoftwares, returns the corresponding options fields.
 * See the IMPUTATIONS_OPTIONS_BY_SOFTWARE config object.
 */
export const getDisplayedImputationsOptions = (
    integratedSoftwares: string[],
): string[] => {
    const matchedSoftwares = new Set(
        integratedSoftwares.filter((software) =>
            Object.keys(IMPUTATIONS_OPTIONS_BY_SOFTWARE).includes(software),
        ),
    );

    if (matchedSoftwares.size === 1) {
        const matchedSoftware: string = matchedSoftwares.values().next().value;
        return IMPUTATIONS_OPTIONS_BY_SOFTWARE[matchedSoftware];
    }
    return IMPUTATIONS_OPTIONS_BY_SOFTWARE.DEFAULT;
};
